import { render, staticRenderFns } from "./pickOne.vue?vue&type=template&id=2996d38f&scoped=true&"
import script from "./pickOne.vue?vue&type=script&lang=js&"
export * from "./pickOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2996d38f",
  null
  
)

export default component.exports